import { TextField } from "@mui/material";
import styles from "../../../../propertydetails.module.css";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { AddLogCallAPI } from "../../../../../../components/AddLogs";
import { toast } from "react-smart-toaster";
import { useState } from "react";

const schema = yup.object().shape({
    parking_gate_command: yup.string().url("Please enter a valid URL")
});

const PropertyParkingGateCommand = ({ parking_gate_command, setLoading, setSnackbarMsg, setSnackbarOpen, setPropertyData, property_name, property_id }) => {
    const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();
    const { handleSubmit, control, errors, setValue } = useForm({
        shouldUnregister: false,
        resolver: yupResolver(schema),
    });

    const [isEditable, setIsEditable] = useState(false);

    useEffect(() => {
        if (parking_gate_command) {
            setValue('parking_gate_command', parking_gate_command);
        }
    }, [parking_gate_command, setValue])

    const onSubmit = async (data) => {
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        setLoading(true);
        return axios.put(process.env.REACT_APP_PROPERTY_API_URL + "v1/properties/" + property_id + "/update-parking-gate-command", data, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            setPropertyData((prev) => {
                return { ...prev, parking_gate_command: response.data?.data?.parking_gate_command };
            });

            let logData = {
                title: "Property parking-gate command has been updated",
                description: ["Property: " + property_name],
            };
            AddLogCallAPI(logData, token);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const executeCommand = async () => {
        if (parking_gate_command === '') {
            toast.error('Please add command first.');
            return false;
        }
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        setLoading(true);
        return axios.get(process.env.REACT_APP_PROPERTY_API_URL + "v1/parking-gate/unlock/" + property_id, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ maxWidth: "420px" }}>
            <div className={`${styles.FormRow}`}>
                <div className={`${styles.FormGroupFullPay} FormGroup`}>
                    <Controller
                        name={`parking_gate_command`}
                        control={control}
                        render={(field) => (
                            <TextField
                                value={field.value}
                                onChange={(e) => {
                                    field.onChange(e);

                                    if (e.target.value !== parking_gate_command) {
                                        setIsEditable(true);
                                    } else {
                                        setIsEditable(false);
                                    }
                                }}
                                label="Parking Gate Unlock Command"
                                variant="outlined"
                            />)}
                    />
                    {errors.parking_gate_command && (<p className={`${styles.ErrorM}`}>{errors?.parking_gate_command?.message}</p>)}
                </div>
            </div>

            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("property-settings:update") > -1 && <div>
                <button type="submit" className={`${styles.ButtonVoiletSolid}`} disabled={!isEditable}>Update</button>
                <button type="button" className={`${styles.ButtonVoiletSolid}`} onClick={(e) => executeCommand()}>Execute</button>
            </div>}
        </div>
    </form>)
}

export default PropertyParkingGateCommand;